import { Form, Modal } from "react-bootstrap";
import "./Send_Inquiry_Modal.css";
import Common_Inquiry_Form from "../../common_component/common_inquiry_form/Common_Inquiry_Form";
import Success_Modal from "../../contact-us/success_modal/Success_Modal";
import { useState } from "react";

function SendInquiryModal({ isOpen, onClose }) {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleSuccess = () => {
    onClose();

    setShowSuccessModal(true);

    setTimeout(() => {
      setShowSuccessModal(false);
    }, 3000);
  };

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        centered
        className="send-inquiry-modal"
      >
        <Modal.Body className="p-0">
          <div className="inquiry-modal">
            <button className="close-btn" onClick={onClose}>
              ✕
            </button>
            <h4 className="modal-title">Get Free Travel Quote</h4>
            <Common_Inquiry_Form onClick={handleSuccess} />
          </div>
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        successText="Inquiry Send !"
      />
    </>
  );
}

export default SendInquiryModal;
